module.exports = "https://web-assets.ifttt.com/packs/media/plan-badges/developer-2d408678.svg";